import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useAuth } from '@kp/react-sdk';
import { Button, Modal, createClasses, pxToRem } from '@kp/react-ui';

import { EmailFormWrapper } from '@/components/EmailForm';

import { useLearnMoreRequest } from '../hooks/useLearnMoreRequest';

const classes = createClasses({
  modal: {
    width: pxToRem(600),
    maxWidth: '100%',
  },
});

export interface LearnMoreButtonProps {
  /** The app the request is about; it names the dialog and the subject. */
  appName: string;
}

/**
 * Opens an e-mail form, prefilled with the signed-in user as the sender, that
 * asks for more information about an app.
 */
export const LearnMoreButton: React.FC<LearnMoreButtonProps> = ({
  appName,
}) => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  const close = () => setOpen(false);
  const { sendLearnMoreRequest, isSending } = useLearnMoreRequest({
    onSuccess: close,
  });

  return (
    <>
      <Button variant="secondary" onClick={() => setOpen(true)}>
        {t('home.apps.learnMore')}
      </Button>
      {open && (
        <Modal
          open
          title={t('home.apps.learnMoreForm.title', { app: appName })}
          className={classes.modal}
          onClose={close}
        >
          <EmailFormWrapper
            formData={{
              fullName: user?.info?.name ?? '',
              email: user?.info?.email ?? '',
              subject: t('home.apps.learnMoreForm.subject', { app: appName }),
              message: '',
            }}
            onSubmit={sendLearnMoreRequest}
            onCancel={close}
            isLoading={isSending}
          />
        </Modal>
      )}
    </>
  );
};
